"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoDataExists = exports.imageDataExists = void 0;
var imageDataExists = function (image) { return (image === null || image === void 0 ? void 0 : image.length) > 0; };
exports.imageDataExists = imageDataExists;
var videoDataExists = function (video) { return (video === null || video === void 0 ? void 0 : video.length) > 0; };
exports.videoDataExists = videoDataExists;
